import { Badge, Box, HStack, Text, Tooltip } from "@chakra-ui/react";

import type { ProfitPushStatus } from "api/types";

import { profitPushPresentation } from "../types/profitPushState";

type Props = {
  status?: ProfitPushStatus | null;
};

/**
 * El semáforo de una orden frente a Profit.
 *
 * No se muestra nada cuando la orden nunca se envió: un badge gris en cada
 * orden del drawer sería ruido sobre el flujo normal, que es simular sin cargar
 * nada en el ERP.
 */
export default function ProfitStatusBadge({ status }: Props) {
  if (!status || status.state === "draft") {
    return null;
  }
  const presentation = profitPushPresentation(status.state);
  const detail = status.profit_order_number
    ? `${presentation.help} OC en Profit: ${status.profit_order_number}.`
    : presentation.help;

  return (
    <Tooltip label={detail} placement="top" hasArrow>
      <HStack spacing="6px" display="inline-flex">
        <Box
          w="8px"
          h="8px"
          borderRadius="full"
          bg={`${presentation.colorScheme}.400`}
        />
        <Badge
          colorScheme={presentation.colorScheme}
          fontSize="10px"
          borderRadius="6px"
          px="6px"
        >
          {presentation.label}
        </Badge>
        {status.profit_order_number ? (
          <Text fontSize="10px" color="gray.500">
            #{status.profit_order_number}
          </Text>
        ) : null}
      </HStack>
    </Tooltip>
  );
}
